import React, { useState } from "react";
import { css } from "react-emotion";
import { withRedux } from "helpers";

const svgStyle = css`
  display: inline-block;
  vertical-align: middle;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
`;

const svgContainer = css`
  display: inline-block;
  padding: 8px;
  border-radius: 25px;
  margin-left: 5px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  background-color: white;
  :hover {
    transform: scale(1.1);
    background-color: #e7e7e7;
  }
`;

const iconPaths = {
  yelp: {
    viewBox: "0 0 24 24",
    children: [
      <g>
        <g>
          <path d="M212.631,250.189C198.728,235.675,112.264,94.753,101.083,78.011c-11.016-16.39-0.908-36.562,16.743-46.582    C142.948,17.235,208.559-3.925,234.164,0.63c25.854,4.629,27.378,26.294,28.037,35.537c3.382,51.188,14.429,180.682,8.716,200.208    c-3.633,12.407-12.803,21.519-24.521,24.39C234.068,263.743,221.549,259.49,212.631,250.189z" />
        </g>
        <g>
          <path d="M61.986,345.535c-6.65-26.44-4.556-67.324,1.187-90.029c6.724-26.569,26.07-35.247,43.418-29.18    c22.225,7.868,52.631,20.709,103.594,41.821c13.052,5.405,20.771,16.523,21.709,31.304c1.055,17.08-8.306,31.758-23.32,36.563    c-3.054,0.958-100.179,32.045-108.838,33.984C82.524,373.847,66.438,363.191,61.986,345.535z" />
        </g>
        <g>
          <path d="M287.558,292.098c-8.892-8.54-13.228-21.152-11.309-32.9c2.124-13.154,72.832-104.297,73.521-105.088    c13.246-15.295,35.008-12.396,50.229,1.729c17.373,16.084,37.925,46.465,46.802,69.155c10.387,26.59-0.776,44.946-19.336,49.805    c-0.908,0.249-102.246,26.06-106.187,26.865C308.275,304.293,296.198,300.398,287.558,292.098z" />
        </g>
        <g>
          <path d="M366,475.863c-16.91-2.77-19.665-8.386-80.229-107.959c-7.397-12.144-6.973-26.177,1.216-38.511    c9.448-14.282,25.298-19.878,41.309-14.604l95.244,31.67c28.557,9.503,37.646,26.749,24.287,54.258    c-10.02,20.61-31.904,48.457-49.79,63.369C388.754,471.831,378.063,477.873,366,475.863z" />
        </g>
        <g>
          <path d="M236.845,511.722c-10.503,0-22.104-2.813-33.574-6.24c-17.93-5.347-33.325-11.66-47.051-19.307    c-29.466-16.469-31.476-37.057-19.966-52.705c8.077-10.999,16.747-20.976,71.968-86.294c9.185-10.884,22.148-14.854,36.504-11.133    c16.274,4.189,27.231,17.534,27.261,33.193c0.071,99.176-0.645,76.789-0.747,109.702    C271.18,498.421,258.857,511.722,236.845,511.722z" />
        </g>
      </g>,
    ],
  },
  snapchat: {
    viewBox: "0 0 24 24",
    children: [
      <g>
        <path d="M508.449,363.081c-4.2-8.101-10.781-14.101-17.68-15.3l-22.2-8.701c-27.301-10.499-48.001-32.098-57.301-58.799   c13.2-3.6,26.1-7.5,38.699-11.7c23.079-7.288,36.63-32.938,28.5-56.7c-7.523-23.823-33.967-36.484-56.699-28.5   c-5.101,1.501-10.201,3.301-15,4.501l0.599-6.301c3.6-42.299-10.499-84.598-39.3-116.1c-28.799-31.5-69.6-49.499-112.2-49.499   s-83.401,17.999-112.2,49.499c-28.801,31.501-42.9,73.801-39.3,116.1l0.599,6.301c-4.799-1.199-9.899-2.999-15-4.501   c-23.737-8.118-49.404,5.399-56.699,28.5c-8.119,23.732,5.394,49.404,28.5,56.7c12.599,4.501,25.8,8.101,39,11.7   c-9.6,26.7-30,48.3-57.001,58.799l-20.4,8.101c-9.901,2.1-16.999,8.699-20.899,17.701c-4.2,9.6-3.001,20.999,3.3,30.599   c4.2,6.301,9.499,12.001,18.2,16.501c12.599,6.899,28.799,10.499,42.599,13.2c5.7,24.899,18.9,35.999,39.3,32.999   c44.7-6.899,49.799-3.6,65.7,8.101c7.2,5.099,16.199,11.699,31.199,19.799c16.201,6.301,34.2,9.901,52.5,9.901   c20.101,0,40.501-4.2,58.2-12.301c3.6-1.8,7.5-4.499,12.001-7.5c18.6-12.599,41.4-28.499,74.099-19.799   c24.251,6.061,40.84-3.87,45.901-31.199c23.699-4.801,53.979-11.7,63.879-35.7C513.248,380.78,512.647,370.879,508.449,363.081z" />
      </g>,
    ],
  },
  instagram: {
    viewBox: "0 0 24 24",
    children: [
      <g>
        <path d="M256,152c-57.9,0-105,47.1-105,105s47.1,105,105,105s105-47.1,105-105S313.9,152,256,152z M256,152   c-57.9,0-105,47.1-105,105s47.1,105,105,105s105-47.1,105-105S313.9,152,256,152z M437,0H75C33.6,0,0,33.6,0,75v362   c0,41.4,33.6,75,75,75h362c41.4,0,75-33.6,75-75V75C512,33.6,478.4,0,437,0z M256,392c-74.399,0-135-60.601-135-135   c0-74.401,60.601-135,135-135s135,60.599,135,135C391,331.399,330.399,392,256,392z M421,122c-16.5,0-30-13.5-30-30s13.5-30,30-30   s30,13.5,30,30S437.5,122,421,122z M256,152c-57.9,0-105,47.1-105,105s47.1,105,105,105s105-47.1,105-105S313.9,152,256,152z    M256,152c-57.9,0-105,47.1-105,105s47.1,105,105,105s105-47.1,105-105S313.9,152,256,152z M256,152c-57.9,0-105,47.1-105,105   s47.1,105,105,105s105-47.1,105-105S313.9,152,256,152z" />
      </g>,
    ],
  },
  facebook: {
    viewBox: "0 0 24 24",
    children: [
      <g>
        <path d="M285.999,512h-90c-8.291,0-15-6.709-15-15V300h-45c-8.291,0-15-6.709-15-15v-90c0-8.291,6.709-15,15-15h45v-75   c0-57.891,47.109-105,105-105h90c8.291,0,15,6.709,15,15v90c0,8.291-6.709,15-15,15h-75v60h75c4.409,0,8.599,1.934,11.44,5.303   c2.856,3.369,4.087,7.808,3.354,12.158l-15,90c-1.201,7.236-7.456,12.539-14.795,12.539h-60v197   C300.999,505.291,294.29,512,285.999,512z" />
      </g>,
    ],
  },
  twitter: {
    viewBox: "0 0 24 24",
    children: [
      <path d="M168.595,461.188c-9.36,0-18.809-0.425-28.315-1.274c-49.438-4.409-93.666-18.442-133.173-42.876   c-5.845-3.618-8.481-10.752-6.401-17.3c2.095-6.533,7.661-10.781,15.22-10.43c36.768,2.256,71.327-4.146,102.748-19.438   c-31.465-11.953-53.569-34.307-67.075-67.632c-1.875-4.629-1.333-9.888,1.465-14.019c0.806-1.201,1.758-2.256,2.842-3.149   c-24.507-20.581-37.573-48.003-39.697-82.896c-0.293-4.805,1.743-9.463,5.464-12.51c2.93-2.417,6.548-3.589,10.386-3.369   c-8.672-14.517-13.638-30.688-14.824-48.428C15.87,117.36,20.748,97.292,32.13,76.505c2.344-4.263,6.606-7.134,11.44-7.69   c4.819-0.557,9.639,1.26,12.876,4.878c48.691,54.302,108.604,85.737,178.315,93.574c0.322-10.283,0.703-20.903,3.296-31.377   c9.214-37.427,36.929-67.075,74.136-79.292c38.76-12.7,80.757-4.658,112.222,21.621c1.875,1.553,2.651,1.831,2.681,1.846   c12.744-4.878,51.489-18.794,51.489-18.794c5.42-1.963,11.44-0.63,15.586,3.384c4.116,4.028,5.566,10.049,3.735,15.498   c-2.52,7.5-5.903,14.546-10.239,21.284c1.86-0.073,4.75-0.103,6.684-0.117c5.024-0.703,10.459,1.201,13.96,5.391   c5.303,6.357,4.658,16.04-1.67,21.357c-0.527,0.439-1.069,0.835-1.626,1.187l-8.599,8.291c-9.639,9.258-20.277,18.516-29.535,28.14   c-1.729,1.787-2.769,3.853-2.93,4.497c-0.425,35.068-6.885,69.653-19.131,102.173C401.285,387.902,292.433,461.188,168.595,461.188   z M430.787,267.067h0.293H430.787z" />,
    ],
  },
  checkMark: {
    viewBox: "0 0 24 24",
    children: [
      <path
        d="M21.856 10.303c.086.554.144 1.118.144 1.697 0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11c2.347 0 4.518.741 6.304 1.993l-1.422 1.457c-1.408-.913-3.082-1.45-4.882-1.45-4.962 0-9 4.038-9 9s4.038 9 9 9c4.894 0 8.879-3.928 8.99-8.795l1.866-1.902zm-.952-8.136l-9.404 9.639-3.843-3.614-3.095 3.098 6.938 6.71 12.5-12.737-3.096-3.096z"
        key="0"
      />,
    ],
  },
  plus: {
    viewBox: "0 0 24 24",
    children: [<path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" key="0" />],
  },
  minus: {
    viewBox: "0 0 24 24",
    children: [<path d="M0 10h24v4h-24z" key="0" />],
  },
  user: {
    viewBox: "0 0 32 32",
    children: [
      <g data-name="41-User" id="_41-User" key="0">
        <circle className="cls-1" cx="16" cy="8" r="7" key="1" />
        <path className="cls-1" key="2" d="M27,26A11,11,0,0,0,5,26v5H27Z" />
      </g>,
    ],
  },
  cancel: {
    viewBox: "0 0 24 24",
    children: [
      <path
        key="0"
        d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"
      />,
    ],
  },
  burger: {
    viewBox: "0 0 32 32",
    children: [
      <path
        key="0"
        d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
      />,
    ],
  },
  shoppingBag: {
    viewBox: "-35 0 512 512.00102",
    children: [
      <path
        key="0"
        d={
          "m443.054688 495.171875-38.914063-370.574219c-.816406-7.757812-7.355469-13.648437-15.15625-13.648437h-73.140625v-16.675781c0-51.980469-42.292969-94.273438-94.273438-94.273438-51.984374 0-94.277343 42.292969-94.277343 94.273438v16.675781h-73.140625c-7.800782 0-14.339844 5.890625-15.15625 13.648437l-38.9140628 370.574219c-.4492192 4.292969.9453128 8.578125 3.8320308 11.789063 2.890626 3.207031 7.007813 5.039062 11.324219 5.039062h412.65625c4.320313 0 8.4375-1.832031 11.324219-5.039062 2.894531-3.210938 4.285156-7.496094 3.835938-11.789063zm-285.285157-400.898437c0-35.175782 28.621094-63.796876 63.800781-63.796876 35.175782 0 63.796876 28.621094 63.796876 63.796876v16.675781h-127.597657zm-125.609375 387.25 35.714844-340.097657h59.417969v33.582031c0 8.414063 6.824219 15.238282 15.238281 15.238282s15.238281-6.824219 15.238281-15.238282v-33.582031h127.597657v33.582031c0 8.414063 6.824218 15.238282 15.238281 15.238282 8.414062 0 15.238281-6.824219 15.238281-15.238282v-33.582031h59.417969l35.714843 340.097657zm0 0"
        }
      />,
    ],
  },
  cart: {
    viewBox: "0 0 446.853 446.853",
    children: [
      <path
        d="M444.274,93.36c-2.558-3.666-6.674-5.932-11.145-6.123L155.942,75.289c-7.953-0.348-14.599,5.792-14.939,13.708
        c-0.338,7.913,5.792,14.599,13.707,14.939l258.421,11.14L362.32,273.61H136.205L95.354,51.179
        c-0.898-4.875-4.245-8.942-8.861-10.753L19.586,14.141c-7.374-2.887-15.695,0.735-18.591,8.1c-2.891,7.369,0.73,15.695,8.1,18.591
        l59.491,23.371l41.572,226.335c1.253,6.804,7.183,11.746,14.104,11.746h6.896l-15.747,43.74c-1.318,3.664-0.775,7.733,1.468,10.916
        c2.24,3.184,5.883,5.078,9.772,5.078h11.045c-6.844,7.617-11.045,17.646-11.045,28.675c0,23.718,19.299,43.012,43.012,43.012
        s43.012-19.294,43.012-43.012c0-11.028-4.201-21.058-11.044-28.675h93.777c-6.847,7.617-11.047,17.646-11.047,28.675
        c0,23.718,19.294,43.012,43.012,43.012c23.719,0,43.012-19.294,43.012-43.012c0-11.028-4.2-21.058-11.042-28.675h13.432
        c6.6,0,11.948-5.349,11.948-11.947c0-6.6-5.349-11.948-11.948-11.948H143.651l12.902-35.843h216.221
        c6.235,0,11.752-4.028,13.651-9.96l59.739-186.387C447.536,101.679,446.832,97.028,444.274,93.36z M169.664,409.814
        c-10.543,0-19.117-8.573-19.117-19.116s8.574-19.117,19.117-19.117s19.116,8.574,19.116,19.117S180.207,409.814,169.664,409.814z
         M327.373,409.814c-10.543,0-19.116-8.573-19.116-19.116s8.573-19.117,19.116-19.117s19.116,8.574,19.116,19.117
        S337.916,409.814,327.373,409.814z"
      />,
    ],
  },
  noImageAvailable: {
    viewBox: "-300 -300 600 600",
    children: [
      <circle
        xmlns="http://www.w3.org/2000/svg"
        stroke="#AAA"
        strokeWidth="10"
        r="280"
        fill="#FFF"
        key="0"
      />,
      <text xmlns="http://www.w3.org/2000/svg" key="1">
        <tspan x="0" y="-8" key="2">
          NO IMAGE
        </tspan>
        <tspan x="0" y="80" key="3">
          AVAILABLE
        </tspan>
      </text>,
    ],
  },
  filledStar: {
    viewBox: "0 0 512 512",
    children: [
      <g>
        <polygon
          points="512,197.816 325.961,185.585 255.898,9.569 185.835,185.585 0,197.816 142.534,318.842 95.762,502.431 
			255.898,401.21 416.035,502.431 369.263,318.842 		"
        />
      </g>,
    ],
  },
  unfilledStar: {
    viewBox: "0 0 512 512",
    children: [
      <g>
        <path
          d="M512,197.819l-185.933-12.228L256,9.571l-70.067,176.021L0,197.82l142.658,120.93L95.856,502.429L256,401.214
        l160.144,101.215l-46.8-183.671L512,197.819z M256,365.724l-112.464,71.08l32.827-128.831L75.829,222.888l130.971-8.603
        L256,90.687l49.2,123.599l131.124,8.602l-100.689,85.077l32.829,128.839L256,365.724z"
        />
      </g>,
    ],
  },
};

function WebIcon({
  iconName,
  useColor,
  customColor,
  size,
  hover,
  textAnchor,
  fontSize,
  className,
  stroke,
  strokeLinejoin,
  strokeWidth,
  ...props
}) {
  const [hovered, setHovered] = useState(false);
  const color = props.activeApp.view.navigation.navBarColor;
  // console.log(customColor);

  const getColor = () => {
    if (useColor && customColor) {
      return customColor;
    } else if (useColor) {
      return color;
    } else {
      return "none";
    }
  };

  return (
    <div
      className={hover ? svgContainer : className}
      onMouseOver={() => {
        if (hover) setHovered(true);
      }}
      onMouseOut={() => setHovered(false)}
    >
      <svg
        className={svgStyle}
        height={size}
        viewBox={iconPaths[iconName].viewBox}
        width={size}
        fill={getColor()}
        textAnchor={textAnchor}
        fontSize={fontSize}
        stroke={stroke ? stroke : "none"}
        strokeLinejoin={strokeLinejoin ? strokeLinejoin : "none"}
        strokeWidth={strokeWidth ? strokeWidth : "none"}
      >
        {iconPaths[iconName].children}
      </svg>
    </div>
  );
}

export default withRedux(WebIcon);
